import axios from 'axios'
import config from './config'
export default {
  getAll (request = {}) {
    return axios.get(config.serverURI + '/task', request)
          .then((response) => Promise.resolve(response))
          .catch((error) => Promise.reject(error))
  }
}


// WEBPACK FOOTER //
// ./src/vuex/api/services/tasks.js